module.exports = __webpack_public_path__ + "static/media/logo_3.4d04ba78.svg";